import { Navigate, Outlet } from "react-router-dom";
import { useContextUsuario } from "../contexto/usuario/UsuarioContext";
import { leerToken } from "../componentes/axios/Axios";

export const AutenticacionRoute = () => {
  const { token, usuario } = useContextUsuario();
  const tokenValido = leerToken();

  if (!token || !usuario || !tokenValido) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};
